import React from 'react';

import {
  CarsFilterResultText,
  CarsFilterResultCount,
} from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { getStockCarList } from '@/store/reducers/cars-stock';

function CarsFilterResult() {
  const carListCount = useTypedSelector(getStockCarList)?.meta?.count;

  if (!carListCount) {
    return null;
  }

  return (
    <CarsFilterResultText>
      <CarsFilterResultCount>{carListCount}</CarsFilterResultCount> авто в
      наличии
    </CarsFilterResultText>
  );
}

export default CarsFilterResult;
